var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    fill: "#728496",
    fillRule: "evenodd",
    d: "M27.289,23.558a1.2,1.2,0,0,0,1.2-1.193V17.95a4.782,4.782,0,0,0-4.78-4.773H22.268V8.968a7.172,7.172,0,0,0-14.341,0v4.208H6.5a4.782,4.782,0,0,0-4.78,4.773v9.785A4.782,4.782,0,0,0,6.5,32.508H23.7a4.782,4.782,0,0,0,4.78-4.773,1.2,1.2,0,0,0-2.39,0,2.391,2.391,0,0,1-2.39,2.387H6.5a2.391,2.391,0,0,1-2.39-2.387V17.95A2.391,2.391,0,0,1,6.5,15.563H23.7a2.391,2.391,0,0,1,2.39,2.387v4.415A1.194,1.194,0,0,0,27.289,23.558ZM19.878,13.177H10.318V8.968a4.783,4.783,0,0,1,9.561,0v4.208ZM13.4,22.841a1.851,1.851,0,1,0,1.85-1.848A1.849,1.849,0,0,0,13.4,22.841Zm-5.832,0a1.85,1.85,0,1,0,1.85-1.848A1.849,1.849,0,0,0,7.571,22.841Zm11.665,0a1.851,1.851,0,1,0,1.851-1.848A1.85,1.85,0,0,0,19.235,22.841Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPassword);
export default __webpack_public_path__ + "static/media/login-password.9417b59e46727d1923e3299596bd06e3.svg";
export { ForwardRef as ReactComponent };